/** Parametri adrese stranice podešavanja: ?t=ekran (bez njega: računar otvara Rokove, telefon početnu) i ?ui=stari. */
export const SETTINGS_QUERY = { screen: "t", legacy: "ui" };
export const LEGACY_UI_VALUE = "stari";
